import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'src/state/store'
import approvalsOperations from '../../../state/ducks/approvals/operations'
import * as localStorage from './approvalReportsStorage'

/**
 * 承認レポート一覧のページネーション機能を提供するhook
 * localStorageに保存されたページネーション状態を管理します
 */
export const useApprovalReportsPagination = () => {
  const dispatch = useDispatch()
  const { request: state } = useSelector(
    (state: RootState) => state.approvalsState.getApprovalReports,
  )

  const updatePagination = (limit: number, offset: number) => {
    approvalsOperations.updatePagination(dispatch, limit, offset)
    localStorage.savePagination(limit, offset)
  }

  return {
    pagination: state,
    updatePagination,
  }
}
